import { ofType } from "redux-observable";
import { catchError, map, mergeMap, of, from, concatMap } from "rxjs";
import {
  renameDocumentRequest,
  renameDocumentSuccess,
  renameDocumentFailure,
  renameLabelRequest,
  renameLabelSuccess,
  renameLabelFailure,
} from "./labelSlice";
import { UploadFileService } from "@/services/UploadFileService";
import { FolderService } from "@/services/FolderService";
import { navigationActions } from "./navigation/navigationSlice";

export const renameLabelEpic = (action$: any) =>
  action$.pipe(
    ofType(renameLabelRequest.type),
    mergeMap((action: any) => {
      const { labelId, newName, currentFolderId, folderRootId } =
        action.payload;
      return from(UploadFileService.Put.renameLabel(labelId, newName)).pipe(
        mergeMap(() => {
          const targetFolderId =
            currentFolderId ||
            folderRootId ||
            localStorage.getItem("folderRootId") ||
            "";
          const apiCall = FolderService.Get.getFilesByFolderId(targetFolderId);
          return from(apiCall).pipe(
            concatMap((response) => [
              renameLabelSuccess({ response }),
              navigationActions.updateBreadcrumbName({
                folderId: labelId,
                newName: newName,
              }),
            ])
          );
        }),
        catchError((error) =>
          of(renameLabelFailure(error?.message || "Rename failed"))
        )
      );
    })
  );

export const renameDocumentEpic = (action$: any) =>
  action$.pipe(
    ofType(renameDocumentRequest.type),
    mergeMap((action: any) => {
      const { id, displayName } = action.payload;
      return from(
        UploadFileService.Patch.updateDocumentDisplayName(id, displayName)
      ).pipe(
        map((response) => renameDocumentSuccess({ response })),
        catchError((error) =>
          of(renameDocumentFailure(error?.message || "Rename failed"))
        )
      );
    })
  );

export const labelEpics = [renameLabelEpic, renameDocumentEpic];
